"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _common = require("../utils/common");
/**
 * 映射单个数据源的类
 */
var Table = /*#__PURE__*/function () {
  function Table(options) {
    (0, _classCallCheck2.default)(this, Table);
    // 表的唯一标示
    this.tableKey = options.tableKey;
    // 当前是否作为主表
    this.isMain = options.isMain;

    // 表的字段schema集
    this.schemaList = options.schemaList || {};

    // 当前表的api请求器
    this.dataApi = undefined;
    this.setRawPrimaryKey();

    // 表的初始查询条件
    this.tableParams = {
      size: 200
    };

    // 与父节点表的关联数据
    this.relationValues = {};

    // 聚合后的关联子表集
    this.forkTableList = [];

    // 表的扩展信息，用于删除、复制等控制
    this.tableExtendInfo = {};

    // 存储的数据集：diff后的状态如下
    // data.__isDepend = true: 在新的数据树中有引用到
    // 1、data.__changeType = 'edit'：编辑数据：变更字段+值，存储在data.__changeFields
    // 2、data.__changeType = 'add'：新增数据：变更字段+值，即是自身data
    // --------------
    // data.__isDepend 已不再引用的数据：等待删除 or 解除关联
    this.dataList = [];
  }

  /**
   * 基于schema设置主键rawPrimaryKey
   */
  (0, _createClass2.default)(Table, [{
    key: "setRawPrimaryKey",
    value: function setRawPrimaryKey() {
      var _this$schemaList;
      var fields = ((_this$schemaList = this.schemaList) === null || _this$schemaList === void 0 ? void 0 : _this$schemaList.fields) || [];
      for (var i = 0; i < fields.length; i++) {
        var primaryKey = (0, _common.getPrimaryBySchema)(fields[i]);
        if (primaryKey) {
          this.rawPrimaryKey = primaryKey;
          return;
        }
      }
    }
  }, {
    key: "primaryKey",
    get: function get() {
      // 真正的主键是允许修改的，所以这里操作时用_id
      return '_id';
    }
  }]);
  return Table;
}();
var _default = Table;
exports.default = _default;